import * as React from "react";
import {
  Box,
  Typography,
  Paper,
  TextField,
  Button,
  Alert,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import ForumIcon from "@mui/icons-material/Forum";
import { API_BASE_URL } from "../api/config";
import { rawFetch } from "../api/httpClient";

export const ChatList = () => {
  const [userId, setUserId] = React.useState("");
  const [conversations, setConversations] = React.useState([]);
  const [, setLoading] = React.useState(false);
  const [senderId, setSenderId] = React.useState("");
  const [recipientId, setRecipientId] = React.useState("");
  const [oneConversation, setOneConversation] = React.useState(null);

  const fetchAllConversations = async () => {
    if (!userId.trim()) return;
    setLoading(true);
    try {
      const res = await rawFetch(`${API_BASE_URL}/chat/all-conversation?recipientId=${userId.trim()}`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setConversations(Array.isArray(json) ? json : json?.data ?? []);
    } catch (e) {
      setConversations([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchOneConversation = async () => {
    if (!senderId.trim() || !recipientId.trim()) return;
    setOneConversation(null);
    try {
      const params = new URLSearchParams({ senderId: senderId.trim(), recipientId: recipientId.trim() });
      const res = await rawFetch(`${API_BASE_URL}/chat/conversation?${params}`, {
        headers: { "X-React-Admin": "true" },
      });
      if (!res.ok) throw new Error(await res.text());
      const json = await res.json();
      setOneConversation(json);
    } catch (e) {
      setOneConversation({ error: e.message });
    }
  };

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <ForumIcon /> Chat / Conversations
      </Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        GET /chat/all-conversation?recipientId={"{userId}"}. Une conversation : GET /chat/conversation?senderId=&recipientId=. Envoyer : POST /chat/send.
      </Alert>
      <Box sx={{ mb: 2 }}>
        <TextField size="small" label="User ID (recipient)" value={userId} onChange={(e) => setUserId(e.target.value)} sx={{ mr: 1 }} />
        <Button variant="contained" onClick={fetchAllConversations} disabled={!userId.trim()}>
          Toutes les conversations
        </Button>
      </Box>
      {conversations.length > 0 && (
        <Paper sx={{ p: 2, mb: 2 }}>
          <Typography variant="subtitle1">Conversations ({conversations.length})</Typography>
          <List dense>
            {conversations.map((c, i) => (
              <ListItem key={c.id ?? i}>
                <ListItemText primary={c.id ?? JSON.stringify(c)} />
              </ListItem>
            ))}
          </List>
        </Paper>
      )}
      <Paper sx={{ p: 2 }}>
        <Typography variant="subtitle1" gutterBottom>Une conversation entre deux users</Typography>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
          <TextField size="small" label="Sender ID" value={senderId} onChange={(e) => setSenderId(e.target.value)} />
          <TextField size="small" label="Recipient ID" value={recipientId} onChange={(e) => setRecipientId(e.target.value)} />
          <Button variant="outlined" onClick={fetchOneConversation}>Charger</Button>
        </Box>
        {oneConversation && (
          <Box sx={{ mt: 2, p: 1, bgcolor: "grey.100", borderRadius: 1 }}>
            {oneConversation.error ? (
              <Typography color="error">{oneConversation.error}</Typography>
            ) : (
              <pre style={{ fontSize: 12, maxHeight: 300, overflow: "auto" }}>{JSON.stringify(oneConversation, null, 2)}</pre>
            )}
          </Box>
        )}
      </Paper>
    </Box>
  );
};
